module.exports = __webpack_public_path__ + "img/pauschale-aufgebraucht.bfd50c4d.svg";